<template>
  <div class="file-section">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="mt-0">
          <strong>{{ sectionName }}</strong>
        </h3>
      </div>
    </div>
    <div class="row" v-for="({ name, fileName, fileType, description }, idx) in files" :key="idx">
      <div class="col-xs-12">
        <div class="media">
          <div class="media-left">
            <img :src="`/capsiminbox/images/${fileTypeIcons[fileType]}`" width="30" />
          </div>
          <div class="media-body">
            <p>
              <a target="_blank" :href="getUrl(fileName)"
                ><strong> {{ name }} ({{ fileType }}) </strong></a
              >
              <br />
              {{ description }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      sectionName: {
        type: String,
        required: true,
      },
      files: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        fileTypeIcons: {
          Video: 'video-file.png',
          PDF: 'pdf-file.png',
          Word: 'word-file.png',
        },
        resourcePath: '/capsiminbox/resources/',
      };
    },

    methods: {
      getUrl(fileName) {
        if (fileName.indexOf('.mp4') >= 0) {
          return fileName;
        } else return this.resourcePath + fileName;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .media {
    margin-bottom: 30px;
    .media-left {
      vertical-align: middle;
    }
    p {
      margin-bottom: 0;
    }
  }
</style>
